import { CHAIN_CONFIG } from './networks';

// Multi-chain token configuration
export const MULTI_CHAIN_CONFIG = {
  USDT: {
    TON: {
      mainnetAddress: 'EQBynBO23ywHy_CgarY9NK9FTz0yDsG82PtcYl_vy6UEZqoP',
      testnetAddress: 'EQB-MPwrd1G6WKNkLz_VnV6WqBDd142KMQv-g1O-8QUA3728',
    },
    BNB: {
      mainnetAddress: '0x55d398326f99059fF775485246999027B3197955',
      testnetAddress: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
    }
  },
  USDC: {
    TON: {
      mainnetAddress: 'EQB-6RaBJT5bBPmgZUlBEgTvN3R0Gb_BBgPE8kqZWVwPUYKF',
      testnetAddress: 'EQBCFwW8uFUh-amdRmNY9NyeDEaeDYXd_xtFsnw5bbxPQh7q',
    },
    BNB: {
      mainnetAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      testnetAddress: '0x64544969ed7EBf5f083679233325356EbE738930',
    }
  }
};

export const MAIN_ASSETS = {
  TON: {
    ...CHAIN_CONFIG.TON,
    chain: 'TON', // Ensure chain property is set
    icon: '◇',
    iconClass: 'ton',
    category: 'Network Token',
    image: '/assets/tokens/ton.png',
    coingeckoId: 'the-open-network',
    fallbackImage: 'https://ui-avatars.com/api/?name=TON&background=2B5AFF&color=fff&size=128'
  },
  BNB: {
    ...CHAIN_CONFIG.BNB,
    chain: 'BNB', // Ensure chain property is set
    icon: 'BNB',
    iconClass: 'bnb',
    category: 'Network Token',
    image: '/assets/tokens/bnb.png',
    coingeckoId: 'binancecoin',
    fallbackImage: 'https://ui-avatars.com/api/?name=BNB&background=F3BA2F&color=fff&size=128'
  },
  /*
  TRG: {
    address: '0x5e0D810B7cE1E1d24bEE4525B0fC62ba1aB80800', // Correct BSC mainnet address
    name: 'Trigo',
    symbol: 'TRG',
    decimals: 18,
    chain: 'BNB',
    type: 'BEP20',
    iconClass: 'trigo',
    icon: '₮',
    category: 'Platform Token',
    image: '/assets/tokens/tgr.png',
    coingeckoId: 'trigo',
    isPlatformToken: true,
    fallbackImage: 'https://ui-avatars.com/api/?name=TGR&background=34D399&color=fff&size=128'
  },
  */
  XAU: {
    address: '0x0000000000000000000000000000000000000000', // Native token usually has null address or specific one
    name: 'EGold',
    symbol: 'XAU',
    decimals: 18,
    chain: 'EGC',
    type: 'Native',
    iconClass: 'xau',
    icon: 'G',
    category: 'Platform Token',
    image: require('../assests/EGoldChain Logo Symbol.png'),
    coingeckoId: 'egold', // Placeholder
    isPlatformToken: true,
    fallbackImage: 'https://ui-avatars.com/api/?name=XAU&background=D4AF37&color=fff&size=128'
  },
  USDT: {
    name: 'Tether',
    symbol: 'USDT',
    decimals: 6,
    iconClass: 'usdt',
    icon: '$',
    category: 'Stablecoin',
    image: '/assets/tokens/usdt.png',
    coingeckoId: 'tether',
    isMultiChain: true,
    supportedChains: ['TON', 'BNB'],
    fallbackImage: 'https://ui-avatars.com/api/?name=USDT&background=26A17B&color=fff&size=128'
  },
  USDC: {
    name: 'USD Coin',
    symbol: 'USDC',
    decimals: 6,
    iconClass: 'usdc',
    icon: '$',
    category: 'Stablecoin',
    image: '/assets/tokens/usdc.png',
    coingeckoId: 'usd-coin',
    isMultiChain: true,
    supportedChains: ['TON', 'BNB'],
    fallbackImage: 'https://ui-avatars.com/api/?name=USDC&background=2775CA&color=fff&size=128'
  }
};

export const POPULAR_BEP20_TOKENS = {
  mainnet: [
    /*
    {
      address: '0x5e0D810B7cE1E1d24bEE4525B0fC62ba1aB80800',
      name: 'Trigo',
      symbol: 'TRG',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'trigo',
      icon: '₮',
      category: 'Platform Token',
      image: '/assets/tokens/tgr.png',
      isPlatformToken: true,
      fallbackImage: 'https://ui-avatars.com/api/?name=TGR&background=34D399&color=fff&size=128'
    },
    */
    {
      address: '0x0000000000000000000000000000000000000000',
      name: 'EGold',
      symbol: 'XAU',
      decimals: 18,
      chain: 'EGC',
      type: 'Native',
      iconClass: 'xau',
      image: require('../assests/EGoldChain Logo Symbol.png'),
      isPlatformToken: true,
      fallbackImage: 'https://ui-avatars.com/api/?name=XAU&background=D4AF37&color=fff&size=128'
    },
    {
      address: '0x55d398326f99059fF775485246999027B3197955',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'usdt',
      image: '/assets/tokens/usdt.png',
      fallbackImage: 'https://ui-avatars.com/api/?name=USDT&background=26A17B&color=fff&size=128'
    },
    {
      address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'usdc',
      image: '/assets/tokens/usdc.png',
      fallbackImage: 'https://ui-avatars.com/api/?name=USDC&background=2775CA&color=fff&size=128'
    }
    // Commented tokens (can be re-enabled later)
    /*
    {
      address: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
      symbol: 'ETH',
      name: 'Ethereum Token',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'eth',
      image: '/assets/tokens/eth.png',
      fallbackImage: 'https://ui-avatars.com/api/?name=ETH&background=627EEA&color=fff&size=128'
    },
    {
      address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
      name: 'Binance-Peg BTCB Token',
      symbol: 'BTCB',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'btc',
      image: '/assets/tokens/btc.png',
      fallbackImage: 'https://ui-avatars.com/api/?name=BTCB&background=F7931A&color=fff&size=128'
    }
    */
  ],
  testnet: [
    /*
    {
      address: '0xC_1YoM8RBixN95lz7odcF3Vrkc_N8Ne9yXV5gS0UQPntr_',
      name: 'Trigo',
      symbol: 'TRG',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'trigo',
      icon: '₮',
      category: 'Platform Token',
      image: '/assets/tokens/tgr.png',
      isPlatformToken: true,
      fallbackImage: 'https://ui-avatars.com/api/?name=TGR&background=34D399&color=fff&size=128'
    },
    */
    {
      address: '0x0000000000000000000000000000000000000000',
      name: 'EGold',
      symbol: 'XAU',
      decimals: 18,
      chain: 'EGC',
      type: 'Native',
      iconClass: 'xau',
      image: require('../assests/EGoldChain Logo Symbol.png'),
      isPlatformToken: true,
      fallbackImage: 'https://ui-avatars.com/api/?name=XAU&background=D4AF37&color=fff&size=128'
    },
    {
      address: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
      symbol: 'USDT',
      name: 'Tether USD',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'usdt',
      image: '/assets/tokens/usdt.png',
      fallbackImage: 'https://ui-avatars.com/api/?name=USDT&background=26A17B&color=fff&size=128'
    },
    {
      address: '0x64544969ed7EBf5f083679233325356EbE738930',
      symbol: 'USDC',
      name: 'USD Coin',
      decimals: 18,
      chain: 'BNB',
      type: 'BEP20',
      iconClass: 'usdc',
      image: '/assets/tokens/usdc.png',
      fallbackImage: 'https://ui-avatars.com/api/?name=USDC&background=2775CA&color=fff&size=128'
    }
  ]
};